import ConnectedPreferDesktopBanner, {
  PreferDesktopBanner,
} from './PreferDesktopBanner';

export default ConnectedPreferDesktopBanner;
export { PreferDesktopBanner };
